import React from "react";
import { Menu, UnstyledButton, Divider } from "@mantine/core";

import { withRouter } from "../utilities/withRouter";
import { IconDotsVertical } from "@tabler/icons-react";

function MaterialThreeDotMenu(props) {
	const [opened, setOpened] = React.useState(false);

	const menuItems = props.menuItems.filter(Boolean);

	// Collect file upload items that need inputs outside the menu
	const uploadItems = menuItems.filter(
		(item) =>
			item.type === "single-upload" || item.type === "multi-file-upload"
	);

	return (
		<div
			className={props.className || ""}
			style={opened ? { display: "inline" } : undefined}
		>
			{/* Hidden file inputs placed outside menu so they persist after menu closes */}
			{uploadItems.map((item) => {
				const inputId = `material-menu-upload-${item.uniqueId}`;
				return (
					<input
						key={inputId}
						id={inputId}
						disabled={item.disabled}
						type="file"
						multiple={item.type === "multi-file-upload"}
						style={{ display: "none" }}
						onChange={(event) => {
							const files = event.target.files;
							if (item.fileListChangeHandler && files.length) {
								item.fileListChangeHandler(files, () =>
									console.log(
										"material menu file upload callback"
									)
								);
							}
						}}
						accept={item.uploadAccept || "*"}
						onClick={(event) => {
							event.target.value = null;
						}}
					/>
				);
			})}
			<Menu
				opened={opened}
				onChange={setOpened}
				position="right-start"
				withinPortal
			>
				<Menu.Target>
					<UnstyledButton
						style={{
							position:
								props.position === "relative"
									? "relative"
									: "absolute",
						}}
					>
						{props.buttonContent ? (
							props.buttonContent
						) : (
							<IconDotsVertical
								size={20}
								style={{
									verticalAlign: "text-top",
								}}
							/>
						)}
					</UnstyledButton>
				</Menu.Target>
				<Menu.Dropdown style={{ maxHeight: "70vh", overflowY: "auto" }}>
					{menuItems.map((item, i) => {
						if (item.divider) {
							return <Divider key={i} />;
						}
						if (item.sectionHeader) {
							return <Menu.Label key={i}>{item.text}</Menu.Label>;
						}

						const leftSection = item.iconComponent || undefined;

						if (
							item.type === "single-upload" ||
							item.type === "multi-file-upload"
						) {
							const inputId = `material-menu-upload-${item.uniqueId}`;

							return (
								item && (
									<span
										title={
											item.disabled
												? item.disabledHoverText
												: null
										}
										key={i}
									>
										<Menu.Item
											disabled={item.disabled}
											leftSection={leftSection}
											onClick={() => {
												if (!item.disabled) {
													const input =
														document.getElementById(
															inputId
														);
													if (input) {
														input.click();
													}
												}
												setOpened(false);
											}}
										>
											{item.text}
										</Menu.Item>
									</span>
								)
							);
						}

						return (
							item && (
								<span
									title={
										item.disabled
											? item.disabledHoverText
											: null
									}
									key={i}
								>
									<Menu.Item
										disabled={item.disabled}
										leftSection={leftSection}
										color={item.color}
										onClick={
											item.href
												? () => {
														const { history } =
															props;
														item.selectCallback &&
															item.selectCallback();
														history.push(item.href);
														setOpened(false);
													}
												: () => {
														item.onSelect();
														setOpened(false);
													}
										}
									>
										{item.text}
									</Menu.Item>
								</span>
							)
						);
					})}
				</Menu.Dropdown>
			</Menu>
		</div>
	);
}
export default withRouter(MaterialThreeDotMenu);
